import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductMissions } from '@/features/missions'
import { MissionsListSkeleton } from '@/features/missions/components/MissionsListSkeleton'

export const Route = createFileRoute('/_event/missoes/')({
  // Declarado ao lado do componente que ele representa: rota nova nasce
  // coberta pelo default, e nenhum registro central precisa ser lembrado.
  staticData: { bootSkeleton: MissionsListSkeleton },
  component: DigitalProductMissionsPage
})

function DigitalProductMissionsPage() {
  return <DigitalProductMissions />
}
